/** Strings only the hosted build has: the Photoshop, Canva and Figma
 *  destinations of Export and Import, and the admin's agent feedback. The
 *  open-source build carries no such namespace, so this file stays out of
 *  ports to it. */
export const hosted = {
  exportTitle: 'Export from Doop',
  exportLede:
    'Pick where your frames go. PDF, Photoshop and Canva let you choose frames next; Figma takes your selection as is.',
  exportPdfSource: 'PDF document',
  exportPdfSourceBlurb: 'One vector page per frame, text stays selectable.',
  psdSource: 'Photoshop file',
  exportPsdSourceBlurb: 'A layered PSD per frame, text and groups still editable.',
  canvaSource: 'Canva design',
  exportCanvaSourceConnect: 'Connect Canva first. Each frame becomes a design.',
  exportCanvaSourceBlurb: 'Each frame becomes a Canva design you can keep editing.',
  exportFigmaSource: 'Figma',
  exportFigmaSourceBlurb: 'Editable text, shapes and images through the Doop plugin.',
  exportPsdTitle: 'Export as Photoshop files',
  exportPsdLede: 'Each frame you check downloads as its own layered PSD, with text and groups still editable.',
  exportPsdNote: 'A busy frame can take a few seconds to render.',
  exportPsdAction: 'Download PSD',
  exportPsdActionMany: 'Download {count} PSDs',
  exportCanvaTitle: 'Export to Canva',
  exportCanvaLede:
    'Each frame you check becomes a new Canva design with live text boxes. Canva renders them one at a time.',
  exportCanvaNote: 'Each design opens in a new tab as it lands — this can take a minute or two per frame.',
  exportCanvaAction: { one: 'Send {count} frame to Canva', other: 'Send {count} frames to Canva' },
  exportCanvaConnectLede:
    'Each frame becomes a new Canva design with live text boxes. Connect your Canva account on the Integrations page first, then come back and pick Canva again.',
  exportCanvaConnectNote: 'Connecting takes a minute and only happens once.',
  openIntegrations: 'Open Integrations',
  integrations: 'Integrations',
  canvasExportTitle: 'Export frames to Photoshop, Canva or Figma',

  frameExportLede: 'Download an image or layered file, or continue editing in Canva or Figma.',
  frameExportLedeFigma: 'Download an image or layered file, or continue editing in Figma.',
  frameExportPsd: 'Download PSD',
  frameExportPsdHint: 'Layered Photoshop file with editable text and groups',
  frameExportCanvaConnectBefore: 'Connect Canva in the',
  frameExportCanvaConnectAfter: 'tab first.',
  sendToFigma: 'Send to Figma…',
  sendFramesToFigma: { one: 'Send {count} frame to Figma…', other: 'Send {count} frames to Figma…' },

  importPsdBlurb: 'Every layer becomes an editable element.',
  importCanvaBlurb: 'Paste a design link. Pages become frames.',
  importDesign: 'Import design',
  canvaDisconnectCopy: 'Frames already imported stay on your canvases.',
  figmaDisconnectCopy: 'Importing from Figma will ask you to connect again. Frames already on your canvases stay.',

  searchFeedback: 'Search agent feedback',
} as const
